import { RootStateOrAny } from 'react-redux';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { Dispatch } from 'react';
import {
  oneDataFetchye,
  oneErrorOnNotOkFetchye,
} from '@americanexpress/fetchye-amex';
import { oneMembershipDomainFetchye } from '@americanexpress/consumer-travel-base';
import {
  getNavigationOneCmsUrlSelector,
  getPersonaApiUrl,
} from '../selectors/apiSelectors';
import { MODULE_NAME } from '../constants/commonConstants';
import { MEMBERSHIP_DOMAIN_QUERY } from '../graphql/membershipQuery';
import { NavigationLinks } from '../types/NavigationLinks';
import {
  fetchyeOpts,
  generateReporting,
  getPersonaAccounts,
  personaHeaders,
} from '../utils/apiUtils';
import { HTTP_METHODS, MEMBERSHIP_DOMAIN_CLIENT_ID } from '../constants/apiConstants';

export const isLoggedInThunk: RootStateOrAny = async (dispatch: Dispatch<unknown>) => {
  const { data } = await dispatch(oneDataFetchye('ReadUserSession.v1', { method: 'GET' })) as RootStateOrAny;
  return !!data?.ok;
};

export const membershipDomainApiThunk = async (
  dispatch: RootStateOrAny,
  getState: RootStateOrAny
) => {
  const state = getState();
  const isLoggedIn = await dispatch(isLoggedInThunk);
  const activeLocale = getActiveLocaleSelector(state);

  const fetcherOpts = {
    reporting: {
      moduleID: MODULE_NAME,
      component: 'membershipDomainApiThunk',
    },
    locale: activeLocale,
  };

  return isLoggedIn && dispatch(
    oneMembershipDomainFetchye(
      { query: MEMBERSHIP_DOMAIN_QUERY },
      { headers: { 'X-Client-Id': MEMBERSHIP_DOMAIN_CLIENT_ID } },
      fetcherOpts
    )
  );
};

export const navigationLinksThunk: RootStateOrAny = async (
  dispatch: Dispatch<unknown>,
  getState: () => RootStateOrAny
) => {
  const state = getState();

  return dispatch(
    oneErrorOnNotOkFetchye<NavigationLinks>(
      `${getNavigationOneCmsUrlSelector(state)}`,
      fetchyeOpts,
      generateReporting(
        'src/thunks/navigationLinksThunk'
      )
    )
  );
};

export const personaApiThunk: RootStateOrAny = async (
  dispatch: Dispatch<unknown>,
  getState: () => RootStateOrAny
) => {
  const state = getState();
  const locale = getActiveLocaleSelector(state);
  const { data: membershipApiData } = await dispatch(membershipDomainApiThunk) as RootStateOrAny;
  const { data: navigationLinks }:
      {data: NavigationLinks} = await dispatch(navigationLinksThunk) as RootStateOrAny;
  const showBenefits = navigationLinks?.features.benefits === 'true';
  const cards = getPersonaAccounts(membershipApiData);
  return cards && showBenefits && dispatch(
    oneErrorOnNotOkFetchye(
      `${getPersonaApiUrl(state)}`,
      {
        ...personaHeaders(locale),
        method: HTTP_METHODS.POST,
        credentials: 'include',
        body: JSON.stringify({
          cards,
        }),
      },
      generateReporting(
        'src/thunks/personaApiThunk'
      )
    )
  );
};
